import { Injectable } from '@angular/core';
import { ApiService } from '../../../../_core/_services/api.service';
import { BaseEntityService } from './base-entity.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SitesService extends BaseEntityService<any> {
  protected endpoint = 'site';

  constructor(api: ApiService) {
    super(api);
  }

  // Override addData to handle Site-specific logic
  override addData(data: any): Observable<any> {
    const new_value = { ...data };
    console.log('Adding Site:', new_value);

    return this.api.postAPI<any>('site', new_value).pipe(
      map((res: any) => {
        if (res && res.body) {
          this.data.push(res.body);
          this.data$.next([...this.data]);
          console.log('Site data updated, current count:', this.data.length);
        }
        return res;
      })
    );
  }

  // Override updateData to handle Site-specific logic
  override updateData(id: number, data: any): Observable<any> {
    const new_value = { ...data };
    console.log('Updating Site:', { id, data: new_value });

    return this.api.putAPI<any>('site', id, new_value).pipe(
      map((res: any) => {
        if (res && res.body) {
          const index = this.data.findIndex((site) => site.id === id);
          if (index !== -1) {
            this.data[index] = { ...this.data[index], ...res.body };
            this.data$.next([...this.data]);
            console.log('Site data updated, current count:', this.data.length);
          }
        }
        return res;
      })
    );
  }

  // Override deleteData to handle Site-specific logic
  override deleteData(id: number): Observable<any> {
    console.log('Deleting Site:', id);

    return this.api.deleteAPI<any>('site', id).pipe(
      map((res: any) => {
        console.log('Site delete response:', res);
        const index = this.data.findIndex((site) => site.id === id);
        if (index !== -1) {
          this.data.splice(index, 1);
          this.data$.next([...this.data]);
          console.log('Site data updated, current count:', this.data.length);
        }
        return res;
      })
    );
  }

  // Legacy methods for backward compatibility
  getSites(queryParams?: any) {
    return this.getData(queryParams);
  }

  addSite(value: any) {
    return this.addData(value);
  }

  updateSite(id: any, value: any) {
    return this.updateData(id, value);
  }

  deleteSite(id: any) {
    return this.deleteData(id);
  }
}
